import React from "react";
import { Modal, Button } from "react-bootstrap";

const CookieConsent = ({ show = true, handleClose }) => {
  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header className="bg-success text-white">
        <Modal.Title>Cookie Consent</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Our website uses cookies for a better experience. Continue to use the
        site as normal if you are happy with this. Otherwise, contact your line
        manager with any queries
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleClose}>
          Accept All
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CookieConsent;
